export const FREE_DELIVERY_PRODUCTS_MODAL_SIZE = 25;
export const BULK_CALL_TIMEOUT = 500;
